import API from '@/helpers/api';

// eslint-disable-next-line import/prefer-default-export
export async function find() {
  return API('/doctoralia/expenses').fetch();
}
